export function getUniqueId() {
  return crypto.randomUUID();
}
